export default __webpack_public_path__ + "static/media/loop-icon.9fe79703.svg";